import ReactMounter from 'lib/ReactMounter'
import InvestmentLocationsPage from 'pages/InvestmentLocationsPage/InvestmentLocationsPage'

ReactMounter.registerComponentToMountOnLoad('InvestmentLocationsPage', InvestmentLocationsPage)
